import { useEffect, useState } from "react";
import { getWaPublic, waLink } from "@/lib/whatsapp";
import WaIcon from "@/components/whatsapp/WaIcon";

export default function WaProductButton({ product }) {
    const [cfg, setCfg] = useState(null);
    useEffect(() => { getWaPublic().then(setCfg); }, []);
    if (!cfg?.product_button_enabled) return null;

    const code = product.part_number || product.name;
    const text = `Përshëndetje, dua informacion për produktin ${code}${product.name && product.name !== code ? ` (${product.name})` : ""}. ${window.location.href}`;
    const ask = () => {
        window.open(waLink(cfg.number, text), "_blank", "noopener");
    };
    return (
        <button type="button" onClick={ask} className="inline-flex items-center justify-center gap-2 rounded-full bg-[#25D366] hover:bg-[#1ebe5b] text-white font-bold text-sm px-5 py-3 transition-colors" data-testid="wa-product-button">
            <WaIcon className="w-5 h-5" /> Pyet në WhatsApp
        </button>
    );
}
